import { render, staticRenderFns } from "./ActiveNow.vue?vue&type=template&id=4542b9fd&"
import script from "./ActiveNow.vue?vue&type=script&lang=js&"
export * from "./ActiveNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports